import { createContext, useContext } from 'react'
import { SummaryItem as SummaryItemType } from '@renderer/chat/types'

export interface SummaryContextValue {
  summary: SummaryItemType
  isExpanded: boolean
  setExpanded: (expanded: boolean) => void
  isEditing: boolean
  setEditing: (editing: boolean) => void
  edited: string | undefined
  setEdited: (edited: string | undefined) => void
  isGenerating: boolean
  setIsGenerating: (generating: boolean) => void
  hasInteracted: boolean
}

export const SummaryContext = createContext<SummaryContextValue | undefined>(undefined)

export function useSummaryContext() {
  const context = useContext(SummaryContext)
  if (!context) {
    throw new Error('useSummaryContext must be used within a SummaryProvider')
  }
  return context
}
